// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29KSA","type":"styles_type__3uACE","choices":"styles_choices__aQcLT"};